// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__TisNB","select":"Header_select__RV0G0","clinic":"Header_clinic__1LkYh"};